
import { Vue, Component } from "vue-property-decorator";
import RevisionsPanel from "@/components/Settings/RevisionsPanel.vue";
import { OxySelectorsRevision } from "@/types/revisions";
import { globalStore } from "@/store/store";
import { fetchRemoteOxySelectorsRevisions } from "@/lib/selectors/oxy-selectors";

@Component({
  components: { RevisionsPanel }
})
export default class SelectorsPanelHistoryViewMode extends Vue {
  resourceKey: keyof OxySelectorsRevision = "oxySelectors";

  get selectors() {
    return globalStore.oxySelectors;
  }

  get hasUnsavedChangesPresent() {
    return globalStore.oxySelectorsHasUnsavedChangesPresent;
  }

  get fetchRevisionsMethod() {
    return fetchRemoteOxySelectorsRevisions;
  }
}
